import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-veraz-page',
  templateUrl: './veraz-page.component.html',
  styleUrls: ['./veraz-page.component.scss']
})
export class VerazPageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  volver(): void {
    this.router.navigateByUrl(`/`);
  }
}